import { Component } from '@angular/core';
import { TableModule } from 'primeng/table';
import { ReportsService } from '../../../../services/reports.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { saveAs } from 'file-saver';
import { RouterModule } from '@angular/router';
import { CommonService } from '../../../../services/common.service';

@Component({
    selector: 'app-find-tlr-blue-tag-number',
    imports: [TableModule, CommonModule, FormsModule, RouterModule],
    templateUrl: './find-tlr-blue-tag-number.component.html',
    styleUrl: './find-tlr-blue-tag-number.component.scss'
})
export class FindTlrBlueTagNumberComponent {

  constructor(private report: ReportsService,
    public commonService: CommonService
  ) { }
  airComplianceDetails: any;
  blueTagNumber:string ='';
  showTable :boolean = false;
  showError :boolean = false;
  facilityID :string = '';
  userCAI :string = '';
  fillMendatoryFeild: boolean = false;


  
  ngOnInit() {
    this.facilityID  = this.commonService.getCurrentFacility();
    this.userCAI = this.commonService.getUserCai();
  }

  searchTag(){
    if(this.blueTagNumber){
      this.fillMendatoryFeild = false;
      this.getTLRsForGivenBlueTagNumber( this.blueTagNumber, true);
    } else {
      this.fillMendatoryFeild = true;
    }
  }

  getTLRsForGivenBlueTagNumber(blueTag: string, isOldUser: boolean): void {
    this.report.getTLRsForGivenBlueTagNumber(this.facilityID, blueTag, this.userCAI, isOldUser).subscribe(
      (data: any) => {
        if(data.TableData.length) {
          this.airComplianceDetails = data.TableData;
          this.showTable=true
          this.showError = false;
        } else {
          this.airComplianceDetails = [];
          this.showTable=false;
          this.showError = true;
        }
      },
      (error: any) => {
        console.error('Error fetching air compliance details', error);
      }
    );
  }

  exportToExcel() {
      let params = {
        facilityID: this.commonService.getCurrentFacility(),
        userCAI: this.commonService.getUserCai(),
        blueTag: this.blueTagNumber
      }
      this.report.getTLRsForGivenBlueTagNumberExcel(params)
        .subscribe({
          next: (fileData: any) => {
            if (fileData) {
              saveAs(fileData, 'blueTagNumber.xlsx');
            }
  
          },
          error: (err: any) => {
            console.error('Error fetching report details:', err);
          }
        })
    }
}
